import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ExplainerVideoPopup } from './ExplainerVideoPopup';

export const EXPLAINER_VIDEO_POPUP = Symbol('EXPLAINER_VIDEO');

export const useExplainerVideoPopup = (videoId, isWistia, options) => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(EXPLAINER_VIDEO_POPUP, ExplainerVideoPopup);
  });

  return useCallback(
    (closeCallback = null) => {
      popups.openPopup(EXPLAINER_VIDEO_POPUP, {
        videoId,
        isWistia,
        aspectRatio: options?.aspectRatio || 16 / 9,
        onClose: () => {
          popups.closePopup(EXPLAINER_VIDEO_POPUP);
          if (closeCallback && typeof closeCallback === 'function') {
            closeCallback();
          }
        },
      });
    },
    [popups, videoId, isWistia, options?.aspectRatio]
  );
};
